import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { withModalsService } from '@myaccount/transport';
import { apiCallInvalid, checkIfAccountVerified, softFlagRequested } from '@myaccount/account-verification';
import { publish } from '@wh/message-bus';
import React, { Component } from 'react';
import { Modal } from './components';


var CLOSE_MESSAGE = 'modal_close';

var triggerAccountVerification = function triggerAccountVerification(countdownFlag) {
  try {
    var _countdownFlag$contex = countdownFlag.context,
        reminderCountdown = _countdownFlag$contex.reminderCountdown,
        status = _countdownFlag$contex.status;

    if (reminderCountdown || status) {
      publish(softFlagRequested);
    }
  } catch (error) {
    publish(apiCallInvalid);
  }
};

export var EnhancedModal = withModalsService(Modal);

var Modals = function (_Component) {
  _inherits(Modals, _Component);

  function Modals() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modals);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modals.__proto__ || _Object$getPrototypeOf(Modals)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false, url: null, modalId: null }, _this.onClose = function () {
      return _this.setState({ visible: false, url: null, modalId: null });
    }, _this.openModal = function (modalId) {
      _this.setState({
        visible: !!_this.props.urls[modalId],
        url: _this.props.urls[modalId],
        modalId: modalId
      });
    }, _this.onOpen = function (modalId) {
      return modalId === 'withdrawAccountVerification' ? checkIfAccountVerified(triggerAccountVerification, function () {
        return _this.openModal('withdraw');
      }) : _this.openModal(modalId);
    }, _this.handleOnClose = function (_ref2) {
      var data = _ref2.data;

      if (typeof data !== 'string') {
        return;
      }
      if (data === CLOSE_MESSAGE) {
        _this.onClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modals, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.handleOnClose, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleOnClose);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          visible = _state.visible,
          url = _state.url,
          modalId = _state.modalId;

      return React.createElement(EnhancedModal, { visible: visible, onClose: this.onClose, onOpen: this.onOpen, url: url, modalId: modalId });
    }
  }]);

  return Modals;
}(Component);

export default {
  type: '@myaccount/modals',
  renderToPortal: function renderToPortal(_ref3) {
    var data = _ref3.data;
    return React.createElement(Modals, { key: 'modals-feature', urls: data.urls });
  }
};